import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../utils/config';
import axios from 'axios';

const usePermission = (tip, anahtar, permissionType = 'r') => {
  const { user, getAuthHeaders } = useAuth();
  const [hasPermission, setHasPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkPermission = useCallback(async () => {
    if (!user || !user.pozisyon) {
      setHasPermission(false);
      setLoading(false);
      return false;
    }

    try {
      setLoading(true);
      const headers = getAuthHeaders();
      const response = await axios.get(
        `${API_BASE_URL}/yetki/check`,
        {
          params: {
            tip,
            anahtar,
            permission_type: permissionType
          },
          headers
        }
      );

      if (response.data.success) {
        if (!response.data.has_permission && permissionType === 'w') {
          console.warn(`YAZMA YETKİSİ YOK: ${tip}/${anahtar} - Pozisyon: ${user?.pozisyon}`);
        }
        
        setHasPermission(response.data.has_permission);
        return response.data.has_permission;
      } else {
        console.warn(`[Yetki Kontrolü] ${tip}/${anahtar} (${permissionType}): success=false`);
        setHasPermission(false);
        return false;
      }
    } catch (error) {
      console.error(`[Yetki Kontrolü] ${tip}/${anahtar} (${permissionType}) hatası:`, error);
      setHasPermission(false);
      return false;
    } finally {
      setLoading(false);
    }
  }, [user, tip, anahtar, permissionType, getAuthHeaders]);

  useEffect(() => {
    if (tip && anahtar) {
      checkPermission();
    } else {
      setLoading(false);
    }
  }, [tip, anahtar, permissionType, checkPermission]);

  return {
    hasPermission,
    loading,
    checkPermission
  };
};

export default usePermission;